(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Venta', Venta)
		.factory('VentaFecha', VentaFecha);
		
    Venta.$inject = ['$resource', 'DateUtils'];
	VentaFecha.$inject = ['$resource', 'DateUtils'];
	
	function Venta ($resource, DateUtils) {
        var resourceUrl =  'api/ventas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
	function VentaFecha ($resource, DateUtils) {
		var resourceUrl =  'api/ventasfecha';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
				params: {fromDate: null, toDate: null},
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fecha = DateUtils.convertDateTimeFromServer(data.fecha);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
	
})();
